import React, { Component } from 'react';
import PropTypes from 'prop-types';

import EstacioInstroduccioIncidenciesAfegir from './estacioIntroduccioIncidenciesAfegir';
import EstacioIntroduccioIncidenciesTaula from './estacioIntroduccioIncidenciesTaula';

class EstacioIntroduccioIncidencies extends Component {
    render() {
        return (
            <div>
                <EstacioInstroduccioIncidenciesAfegir dataActualText={this.props.dataActualText}/>
                <EstacioIntroduccioIncidenciesTaula dataActualText={this.props.dataActualText}/>
            </div>
        );
    }
}

EstacioIntroduccioIncidencies.propTypes = {
    dataActualText: PropTypes.string.isRequired
};

export default EstacioIntroduccioIncidencies;



// WEBPACK FOOTER //
// ./src/components/estacio/estacioIntroduccioIncidencies.js